import { render, staticRenderFns } from "./picker.vue?vue&type=template&id=1b71a854&scoped=true&"
import script from "./picker.vue?vue&type=script&lang=js&"
export * from "./picker.vue?vue&type=script&lang=js&"
import style0 from "./picker.vue?vue&type=style&index=0&id=1b71a854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71a854",
  null
  
)

export default component.exports